import { StorageKeys, webSessionStorage } from 'obt-common';
import { parseParams } from 'obt-common/utils/urlUtils';

const REDIRECT_URL_QUERY_PARAM_KEY = 'redirectUrl';

export const injectRedirectURLQueryParam = (url: string) => {
  // Take the redirect URL from the session storage.
  // It was added to the session storage when the user hit auth page but was redirected to the login page
  const authRedirectURL = webSessionStorage.getItem(StorageKeys.AUTH_REDIRECT_URL_KEY);

  if (!authRedirectURL) {
    return url;
  }

  const { pathname, search } = parseParams(authRedirectURL);
  const redirectURL = new URL(url);
  redirectURL.searchParams.set(REDIRECT_URL_QUERY_PARAM_KEY, search ? [pathname, search].join('?') : pathname);
  return redirectURL.toString();
};
